import { ApiResponse } from "./index.defs";
import { CalcState } from "../models/Models";
import { InsuranceCard, IRequestOptions, IRequestConfig, getConfigs, axios, basePath } from "./index.defs";

export class CardService {
    static getCalcState(cardId: string, icname: string, options: IRequestOptions = {}): Promise<ApiResponse<InsuranceCard>> {
        return new Promise((resolve, reject) => {
            const url = `${basePath}/card/GetCalcState?cardId=${cardId}&icname=${icname}`;
            const configs: IRequestConfig = getConfigs("get", "application/json", url, options);
            axios(configs, resolve, reject);
        });
    }
    static getCalcStates(cardId: string, options: IRequestOptions = {}): Promise<ApiResponse<CalcState[]>> {
        return new Promise((resolve, reject) => {
            const url = `${basePath}/card/GetCalcStates?cardId=${cardId}`;
            const configs: IRequestConfig = getConfigs("get", "application/json", url, options);
            axios(configs, resolve, reject);
        });
    }
    static getCard(
        params: {
            cardId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<InsuranceCard>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/card/getCard?cardId=" + params.cardId;
            const configs: IRequestConfig = getConfigs("get", "application/json", url, options);
            axios(configs, resolve, reject);
        });
    }

    static saveAndFullIssue(
        params: {
            /**  */
            traceId?: string;
            /**  */
            testAction?: string;
            /** requestBody */
            body?: InsuranceCard;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<string>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/card/saveAndFullIssue";
            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { traceId: params["traceId"], testAction: params["testAction"] };
            const data = params.body;
            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}
